<template>
    <el-menu :default-active="defaultActive" class="" @select="changeView"  mode="horizontal">
        <el-menu-item index="1">
            <i class="el-icon-user-solid"></i>
            <span slot="title">Estado del sprint</span>
        </el-menu-item>
        <el-menu-item index="2">
            <i class="el-icon-s-ticket"></i>
            <span slot="title">Tickets</span>
        </el-menu-item>
        <el-menu-item index="3">
            <i class="el-icon-aim"></i>
            <span slot="title">Accidentes</span>
        </el-menu-item>

    </el-menu>
</template>

<script>
    export default {
        name: "navMenu",
        data:_=>{
            return {
                defaultActive: "1",
                routes:{
                    "1": 'sprint',
                    "2": 'tickets',
                    "3": 'accidents'
                }
            }
        },
        methods:{
            changeView(index){
                this.$router.push(this.routes[index]);
            }
        },
        mounted() {
            this.defaultActive = Object.keys(this.routes)
                .find(i=> this.$route.name === this.routes[i]);
        }
    }
</script>

<style>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }
</style>
